import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TransactionResult } from '../../../../core/services/interfaces/transaction-result';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '../../../../core/services/translate-service';
import { IConsole } from '../Interfaces/IConsole';
import { ConsoleService } from '../services/console-service';
import { ConsoleDetail } from './console-detail/console-detail';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../core/services/notification/notification.service';

@Component({
  selector: 'app-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.scss']
})
export class ConsoleComponent implements OnInit {
  listData: IConsole[] = [];
  loading = false;
  station: string = 'CONSOLE';
  columns: Array<any> = ['id', 'name', 'enabled', 'updated', 'changestatuscolumn'];
  displayedColumns: Array<string> = this.columns.map(c => c.columnDef);


  constructor(
    private consoleService: ConsoleService,
    private notificationService: NotificationService,
    public dialog: MatDialog
  ) {
   
  }

  ngOnInit() {
    //this.getConsoles();
    this.listData.push({ id: 1, name: "Consola 1", updated: new Date(), enabled: true, available: true });
    this.listData.push({ id: 2, name: "Consola 2", updated: new Date(), enabled: true, available: true });
    this.listData.push({ id: 3, name: "Consola 3", updated: new Date(), enabled: false, available: true });
    this.listData.push({ id: 4, name: "Consola 4", updated: new Date(), enabled: true, available: true });
    this.listData.push({ id: 5, name: "Consola 5", updated: new Date(), enabled: true, available: true });
    this.listData.push({ id: 6, name: "Consola 6", updated: new Date(), enabled: false, available: true });
    this.listData.push({ id: 7, name: "Consola 7", updated: new Date(), enabled: true, available: true });
  }

  getConsoles() {
    this.loading = true;
    this.consoleService.GetList().subscribe(
      (result: TransactionResult<IConsole[]>) => {
        this.loading = false;
        if (result.success) {
          this.listData = result.data;
        }
      },
      (error: any) => { this.ErrorAlert(error); this.loading = false; }
    );
  }

  addConsole() {
    const dialogRef = this.dialog.open(ConsoleDetail, {
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.getConsoles();
    });
  }

  editConsole(item: IConsole) {
    const dialogRef = this.dialog.open(ConsoleDetail, {
      data: item
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.getConsoles();
    });
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
  }

  ChangeStatus(item: any){}
}
